<app-settings-sub-header
    [headerData]="subHeaderData"
    [idmsSettingForm]="idmsFormGroup"
    [generalTabIndex]="generalTabIndex"
    [idmsPassPercentageForm]="idmsPassPercentageForm"
></app-settings-sub-header>

<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <div class="setting_sec">
                        <div class="setting_tab" id="setting_tab">
                            <mat-tab-group (selectedTabChange)="tabChanged($event)" class="tab-wrapper">
                                <mat-tab
                                    label="{{ 'SETTING_PAGE.IDMS_SETTINGS.DATABASE_SELECT_LOOKUP_&_MATERIAL_ALIAS' | transloco }}"
                                    *ngIf="isDbLookUpTab || isMaterialAliasTab"
                                    [aria-label]="'DB Select Lookup & Material Alias'"
                                >
                                    <app-db-select-lookup-material-alias [form]="idmsFormGroup"></app-db-select-lookup-material-alias>
                                </mat-tab>

                                <mat-tab
                                    label="{{ 'SETTING_PAGE.IDMS_SETTINGS.PIPE_SPECIFICATIONS' | transloco }}"
                                    *ngIf="viewPipeCodesTab"
                                    [aria-label]="'Pipe Specifications'"
                                >
                                    <app-pipe-codes [idmsFormGroup]="idmsFormGroup"></app-pipe-codes>
                                </mat-tab>

                                <mat-tab
                                    label="{{ 'SETTING_PAGE.IDMS_SETTINGS.BATCH_CALCULATION_STATUS' | transloco }}"
                                    *ngIf="viewPipeCodesTab"
                                    [aria-label]="'Batch Calculation Status'"
                                >
                                    <app-batch-calculation-status></app-batch-calculation-status>
                                </mat-tab>

                                <mat-tab
                                    label="{{ 'SETTING_PAGE.IDMS_SETTINGS.DATA_UPLOADS' | transloco }}"
                                    *ngIf="viewdataUploadTab"
                                    [aria-label]="'Data Uploads'"
                                >
                                    <app-data-uploads [idmsFormGroup]="idmsFormGroup"></app-data-uploads>
                                </mat-tab>

                                <!-- Removed Due to functionality is not done , Need to develop in future  -->
                                <!-- <mat-tab label="Uploads">  
                                    <app-uploads></app-uploads>
                                   <h3>Uploads Tab</h3> 
                                </mat-tab> -->

                                <mat-tab
                                    label="{{ 'SETTING_PAGE.HEADER.MANU_LINKS.INFORMATE' | transloco }}"
                                    *ngIf="viewCalcPefTab"
                                    [aria-label]="'Pipe Specifications'"
                                >
                                    <ng-template matTabContent>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="card card-custom gutter-b card-stretch">
                                                    <app-calculation-preferences-pass-pct
                                                        [form]="idmsPassPercentageForm"
                                                        [passCount]="4"
                                                        [dataSource]="calculationPreferenceSettings"
                                                        style="height: 100%"
                                                    ></app-calculation-preferences-pass-pct>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                <mat-tab
                                    label="{{ 'SETTING_PAGE.IDMS_SETTINGS.BARCODE_QR_CODE' | transloco }}"
                                    *ngIf="viewBarCodeTab"
                                    [aria-label]="'Barcode & QR code'"
                                >
                                    <app-bar-code-qr-code [idmsFormGroup]="idmsFormGroup"></app-bar-code-qr-code>
                                </mat-tab>
                                <!-- <mat-tab label="Approvals">
                                    <app-rules></app-rules>
                                </mat-tab> -->
                                <mat-tab label="{{ 'SETTING_PAGE.IDMS_SETTINGS.RULES' | transloco }}" *ngIf="viewRulesTab" [aria-label]="'Rules'">
                                    <app-rules-approvals
                                        (ruleConfigureFormEmmiter)="ruleConfigureFormEmmiterHandler($event)"
                                        (clearRuleValuesDataEmmiter)="clearRuleValuesDataHandler($event)"
                                        [ruleValues]="ruleValues"
                                    ></app-rules-approvals>
                                </mat-tab>
                                <mat-tab label="{{ 'SETTING_PAGE.IDMS_SETTINGS.APPROVALS' | transloco }}" *ngIf="viewApprovalsTab" [aria-label]="'Approvals'">
                                    <div class="approvals_section">
                                        <app-approvals-content></app-approvals-content>
                                    </div>
                                </mat-tab>
                            </mat-tab-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
